import React from "react";
import { IoClose } from "react-icons/io5";
import { resolveMediaUrl } from "../../../../utility/media";
import { formatCurrency } from "../../../../utility/formatCurrency";
import { useTranslation } from "react-i18next";

const ViewAdminSanctionDetailsModal = ({ isOpen, onClose, plan }) => {
    const {t} = useTranslation();

    if (!isOpen || !plan) return null;

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '900px', maxWidth: '95%' }}>
                {/* Modal Header matching establish style */}
                <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
                    <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        {t('pageTitles.adminSanctionDetails')}
                    </div>
                    <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }}>
                        <IoClose />
                    </button>
                </div>

                <div className="staff-form-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    
                    {/* Primary Plan Information (Read-Only) */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 mt-2 px-4 border-b pb-4">
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap" style={{ marginBottom: 0 }}>
                                {t('tables.workName')} :
                            </label>
                            <span className="text-sm font-bold text-gray-800">{plan.nameOfWork || "N/A"}</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap" style={{ marginBottom: 0 }}>
                                {t('tables.location')} :
                            </label>
                            <span className="text-sm text-gray-700">{plan.districtName || "N/A"}</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap" style={{ marginBottom: 0 }}>
                                {t('tables.workType')} :
                            </label>
                            <span className="text-sm text-gray-700">{plan.workTypeName || "N/A"}</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap" style={{ marginBottom: 0 }}>
                                {t('tables.estimateCost')} :
                            </label>
                            <span className="text-sm font-bold text-gray-600">{formatCurrency(plan.estimateCost) || "0.00"}</span>
                        </div>
                    </div>

                    {/* Admin Sanction Specific Information - Highlighted Section */}
                    <div className="bg-blue-50/50 p-4 mx-4 rounded-lg border border-blue-100 grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap text-blue-800 font-bold" style={{ marginBottom: 0 }}>
                                {t('forms.adminSanction.sanctionedCost')} :
                            </label>
                            <span className="text-sm font-bold">
                                ₹ {formatCurrency(plan.adminCost) || "Pending"}
                            </span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap text-blue-800 font-bold" style={{ marginBottom: 0 }}>
                                {t('forms.adminSanction.sanctionedDate')} :
                            </label>
                            <span className="text-sm font-bold text-gray-800">
                                {plan.adminDate || "Pending"}
                            </span>
                        </div>
                    </div>

                    {/* Attachments Table */}
                    <div className="border border-black rounded-sm overflow-hidden mx-auto mb-4" style={{ width: '95%' }}>
                        <table className="w-full text-sm border-collapse">
                            <thead>
                                <tr className="bg-gray-100 border-b border-black">
                                    <th className="p-2 text-center border-r border-black font-bold w-12">{t('tables.srNo')}</th>
                                    <th className="p-2 border-r border-black font-bold">{t('tables.attachmentDesc')}</th>
                                    <th className="p-2 text-center font-bold w-48">{t('tables.file')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {plan.attachmentData && plan.attachmentData.length > 0 ? (
                                    plan.attachmentData.map((item, index) => (
                                        <tr key={item.id || index} className="border-b border-black last:border-0">
                                            <td className="p-2 text-center border-r border-black">{index + 1}</td>
                                            <td className="p-2 pl-4 text-left border-r border-black whitespace-pre-wrap">
                                                {item.description}
                                            </td>
                                            <td className="p-2 text-center">
                                                {item.attachmentUrl ? (
                                                    <a 
                                                        href={resolveMediaUrl(item.attachmentUrl)} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 underline hover:text-blue-800 break-all"
                                                    >
                                                        {item.attachmentName || "View File"}
                                                    </a>
                                                ) : (
                                                    <span className="text-gray-400 italic">{t('common.noAttachment')}</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="p-4 text-center text-gray-500 italic">
                                            {t('common.noAttachment')}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer matching establishment style */}
                <div className="staff-form-footer">
                    <button className="staff-btn-save" onClick={onClose}>
                        {t('common.close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewAdminSanctionDetailsModal;